import { IAmountSpaces } from 'src/app/shared/interfaces/IAmountSpaces';
import { IGroupBySpaceSize } from 'src/app/shared/interfaces/IHDspace';
import { SPACE_STATES } from 'src/app/shared/utils/constants';

export class SizesLockerFactory {
  constructor(private sizes: Record<number, IGroupBySpaceSize[]>) {}

  getAvailableSpaces(spacesToFilter: IGroupBySpaceSize[] = []): IGroupBySpaceSize[] {
    return spacesToFilter.filter(
      (space) =>
        space.value.state.presence === SPACE_STATES.UNFILL &&
        space.value.state.selectable === SPACE_STATES.AVAILABLE &&
        space.value.state.secure === SPACE_STATES.CLOSE
    );
  }

  createSize(size: number): IAmountSpaces {
    const rawSpaces = this.sizes[size] ?? [];
    const spaces = this.getAvailableSpaces(rawSpaces);

    return {
      selected: false,
      spaces,
    };
  }
}
